<page-load-header *ngIf="!initialized"></page-load-header>

<h3>Component</h3>
<div *ngIf="initialized" class="container-fluid">

</div>